export enum LOCAL_STORAGE_KEYS {
  ACCESS_TOKEN = "accessToken",
  TOKEN = "token",
  EMPLOYEE_ID = "empId"
}

export const UNKNOWN = "UNKNOWN";
